// extracted by mini-css-extract-plugin
module.exports = {"root":"PLPOptionCard_root__PdWyt","root--selected":"PLPOptionCard_root--selected__R8CsU","rotation":"PLPOptionCard_rotation__fjPLv"};